import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/store';
import { updatePolicy } from '../../../../../services/CaseManagementService/policySlice';

const PolicyNumberEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const policy = useAppSelector((state) => state.policy.currentPolicy);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updatePolicy({ policyNumber: event.target.value }));
  };

  return (
    <TextField
      label="Policy Number"
      value={policy?.policyNumber || ''}
      onChange={handleChange}
      size="small"
      required
      placeholder="Enter policy number"
      sx={{ 
        '& .MuiOutlinedInput-root': {
          backgroundColor: '#ffffff',
        }
      }}
    />
  );
};

export default PolicyNumberEditor;
